module.exports = __webpack_public_path__ + "static/media/Adapting Model Sectioning Tool for Autodesk Construction Cloud.69cb191a.png";